import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AssessmentProvider } from "@/context/AssessmentContext";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import NDIS0138LandingPage from "@/pages/NDIS0138LandingPage";
import IntakePage from "@/pages/IntakePage";
import IntakeCompletePage from "@/pages/IntakeCompletePage";
import ResultsPage from "@/pages/ResultsPage";
import ReportPage from "@/pages/ReportPage";
import TermsPage from "@/pages/TermsPage";
import WhatWeDoPage from "@/pages/WhatWeDoPage";
import NotFoundPage from "@/pages/NotFoundPage";
import LoginPage from "@/pages/LoginPage";
import AuthCallbackPage from "@/pages/AuthCallbackPage";
import AdminQuotesPage from "@/pages/AdminQuotesPage";
import { RequireAdmin } from "@/components/auth/RequireAdmin";

function AppRoutes() {
  // Synchronous detection of the OAuth callback fragment before any route
  // component (or AuthProvider's /me check) runs. Prevents race conditions.
  const location = useLocation();
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallbackPage />;
  }
  return (
    <Routes>
      <Route path="/" element={<NDIS0138LandingPage />} />
      <Route path="/home-legacy" element={<HomePage />} />
      <Route path="/intake" element={<IntakePage mode="intake" />} />
      <Route path="/intake/complete" element={<IntakeCompletePage />} />
      <Route path="/questionnaire" element={<RequireAdmin><IntakePage mode="questionnaire" /></RequireAdmin>} />
      <Route path="/results" element={<RequireAdmin><ResultsPage /></RequireAdmin>} />
      <Route path="/report" element={<RequireAdmin><ReportPage /></RequireAdmin>} />
      <Route path="/terms" element={<TermsPage />} />
      <Route path="/what-we-do" element={<WhatWeDoPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/admin/quotes" element={<AdminQuotesPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

function App() {
  return (
    <AuthProvider>
      <AssessmentProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster />
        </BrowserRouter>
      </AssessmentProvider>
    </AuthProvider>
  );
}

export default App;
